import React from 'react';
import { Link } from '@reach/router';


const footer= () => (
  <footer className="footer-light">
            <div className="container">

            </div>
            <div className="subfooter">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="de-flex">
                                <div className="de-flex-col">
                                    <span onClick={()=> window.open("", "_self")}>
                                        <img alt="" className="f-logo d-1" src="./GameLogo.png" height="40" />
                                        <img alt="" className="f-logo d-3" src="./img/logo-2-light.png" />
                                        <span className="copy">&copy; Copyright 2022 - RedZone Studios LLC</span>
                                    </span>
                                </div>
                                <div className="de-flex-col">
                                    <div className="social-icons">
                                    
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
);
export default footer;